import base from './base'

let controller = 'statistics'
let action = null

const Statistics = {
  async guaranteeStatistics (query) {
    let querys = {}
    Object.assign(querys, query)
    action = 'GuaranteeStatistics'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async dashboardStat (query) {
    let querys = {}
    Object.assign(querys, query)
    action = 'DashboardStat'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },


  async statByVarieties (query) {
    let querys = {}
    Object.assign(querys, query)
    action = 'StatByVarieties'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByStatus (query) {
    let querys = {}
    Object.assign(querys, query)
    action = 'StatByStatus'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByUnit (query) {
    let querys = {}
    Object.assign(querys, query)
    action = 'StatByUnit'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByUnitRange (query) {
    let querys = {
      startDate: query.startDate || require('moment')().format('YYYY-01-01'),
      endDate: query.endDate || require('moment')().format('YYYY-MM-DD'),
    }
    Object.assign(querys, query)
    action = 'StatByUnitRange'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByGuarantors (query) {
    let querys = {
      startDate: query.startDate || require('moment')().format('YYYY-01-01'),
      endDate: query.endDate || require('moment')().format('YYYY-MM-DD'),
    }
    Object.assign(querys, query)
    action = 'StatByGuarantors'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByCities (query) {
    let querys = {
      startDate: query.startDate || require('moment')().format('YYYY-01-01'),
      endDate: query.endDate || require('moment')().format('YYYY-MM-DD'),
    }
    Object.assign(querys, query)
    action = 'StatByCities'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByIndustries (query) {
    let querys = {
      startDate: query.startDate || require('moment')().format('YYYY-01-01'),
      endDate: query.endDate || require('moment')().format('YYYY-MM-DD'),
    }
    Object.assign(querys, query)
    action = 'StatByIndustries'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async statByDate (query) {
    let querys = {
      startDate: query.startDate || require('moment')().format('YYYY-01-01'),
      endDate: query.endDate || require('moment')().format('YYYY-MM-DD'),
    }
    Object.assign(querys, query)
    action = 'StatByDate'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  }
}

export default Statistics